var render = function render(){var _vm=this,_c=_vm._self._c;return _c('g',[_c('polygon',{staticClass:"topPolygon",attrs:{"points":_vm.topPolygon}}),_c('polygon',{staticClass:"rightPolygon",attrs:{"points":_vm.rightPolygon}}),_c('rect',{staticClass:"frontRect",attrs:{"x":_vm.x,"y":_vm.y,"width":_vm.width,"height":_vm.height}})])
}
var staticRenderFns = []

export { render, staticRenderFns }